/**
 * Arquivo: src/pages/Configuracoes.tsx
 * Versão: 6.1.0
 * Descrição: configurações em layout de lista, com hierarquia visual de app.
 */
import { useEffect, useState, useSyncExternalStore } from 'react'
import { obterBaseAtiva } from '../services/financeiro'
import { checkPwaUpdate, getPwaUpdateState, subscribePwaUpdate } from '../pwa'
import { version } from '../../package.json'
import { gerarBackup } from '../services/drive'
import type { BaseFinanceira } from '../types/database'

export default function Configuracoes() {
  const update=useSyncExternalStore(subscribePwaUpdate,getPwaUpdateState)
  const [base, setBase] = useState<BaseFinanceira | null>(null)
  const [msg, setMsg] = useState('')
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    obterBaseAtiva().then(setBase)
  }, [])

  const backup = async () => {
    if (!base) return
    setBusy(true)
    setMsg('')
    try {
      const r = await gerarBackup(base.id)
      setMsg(`Backup criado: ${r.nome || 'concluído'}`)
    } catch (e) {
      setMsg(e instanceof Error ? e.message : 'Falha no backup.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <section className="settings-premium-page">
      <div className="page-heading">
        <div>
          <h1>Configurações</h1>
          <p>Integrações, dados e segurança.</p>
        </div>
      </div>

      <div className="settings-native-section">
        <span className="settings-native-title">Integrações</span>
        <div className="settings-native-list">
          <div className="settings-native-row">
            <div>
              <strong>OneDrive</strong>
              <small>Comprovantes e anexos</small>
            </div>
            <span className="settings-status">Armazenamento</span>
          </div>
          <div className="settings-native-detail">
            Comprovantes e anexos armazenados no OneDrive conectado à base. A conexão é gerenciada em Administração.
          </div>
        </div>
      </div>

      <div className="settings-native-section">
        <span className="settings-native-title">Dados</span>
        <div className="settings-native-list">
          <div className="settings-native-row settings-native-action-row">
            <div>
              <strong>Backup da base</strong>
              <small>Exportação completa em JSON para o OneDrive</small>
            </div>
            <button className="settings-native-action" disabled={!base || busy} onClick={() => void backup()}>
              {busy ? 'Gerando…' : 'Gerar agora'}
            </button>
          </div>
          {msg && <div className="settings-native-message">{msg}</div>}
        </div>
      </div>

      <div className="settings-native-section">
        <span className="settings-native-title">Aplicativo</span>
        <div className="settings-native-list">
          <div className="settings-native-row settings-native-action-row"><div><strong>FF Controle Financeiro</strong><small>Versão {version}</small></div><button className="settings-native-action" disabled={update.checking} onClick={()=>void checkPwaUpdate()}>{update.checking?'Verificando…':'Verificar atualização'}</button></div>
          {update.message&&<div className="settings-update-message" role="status">{update.message}</div>}
          {update.available&&<div className="settings-update-message">Nova versão pronta. Para instalar, conclua suas edições e feche e reabra todas as janelas do aplicativo.</div>}
        </div>
      </div>

      <p className="settings-native-footnote">Os backups são gravados na pasta <strong>Backups</strong> do OneDrive.</p>
    </section>
  )
}

